import React, { useMemo } from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { chatMessageProps } from './message-types';
import { MessageWithActions } from './message-with-actions';
import { useIsVivara } from '../../hooks/useIsVivara';
import { Logo } from '../Logo';
import { UserAvatar } from '../Logo/UserAvatar';
import { PlaygroundTheme } from '../../Theme';

const useStyles = createUseStyles<string, unknown, PlaygroundTheme>((theme) => ({
  vivaraMessage: {
    display: 'flex',
    gap: 10,
    '&.vivara-user-message': {
      flexDirection: 'row-reverse',
    },
    '& .ui-chat__message': {
      flex: 1,
    },
  },
  avatar: {
    marginTop: 2,
    backgroundColor: '#F9A370',
    '&.vivara-user-avatar': {
      backgroundColor: theme.themePrimary,
      '& svg': {
        cursor: 'default',
      },
    },
  },
}));

export const ChatMessageWithActions: React.FunctionComponent<chatMessageProps> = (props) => {
  const {
    message, onLike, onDislike, disableLike, disableDislike, isShowDeploymentName, enableAnnotation, onAnnotation, isUserMessage,
  } = props;
  const isVivara = useIsVivara();
  const classes = useStyles();

  const messageContent = useMemo(() => {
    const urlRegex = /\[([^\]]*?)\]\((https?:\/\/[^\s)]+)\)/;
    let updatedMessage = message && message.content;

    if (updatedMessage) {
      const match = updatedMessage.match(urlRegex);
      if (match) {
        const content = match[1];
        const link = match[2];
        updatedMessage = updatedMessage.replace(match[0], `<a href="${link}" target="_blank">${content}</a>`);
      }
    }

    return (
      <div dangerouslySetInnerHTML={{ __html: updatedMessage || '' }} />
    );
  }, [message]);

  const messageComponent = (
    <MessageWithActions
      message={message}
      messageContent={<div>{messageContent}</div>}
      onLike={onLike}
      onDislike={onDislike}
      disableLike={disableLike}
      disableDislike={disableDislike}
      isShowDeploymentName={isShowDeploymentName}
      enableAnnotation={enableAnnotation}
      onAnnotation={onAnnotation}
      isUserMessage={isUserMessage}
    />
  );

  return !isVivara ? messageComponent : (
    <div className={classnames(classes.vivaraMessage, isUserMessage ? 'vivara-user-message' : 'vivara-bot-message')}>
      {isUserMessage ? (
        <UserAvatar />
      ) : (
        <Logo
          size="small"
          className={classnames(classes.avatar, 'vivara-bot-avatar')}
          text="Logo"
        />
      )}
      {messageComponent}
    </div>
  );
};
